import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabs() {



const cardData = {
  keyword: " Pune to Nasik Cabs",

"headingDescription": "Pune to Nasik Cabs service offers a reliable, comfortable, and hassle-free travel experience for passengers planning a trip to Nashik. Whether it’s a religious visit, business trip, family outing, or weekend getaway, our professional drivers and well-maintained vehicles ensure a smooth journey. We provide one-way rides, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Nasik Cabs, enjoy easy online booking, 24/7 customer support, and a convenient ride across Maharashtra.",
"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage site near Nashik. Travelers booking Pune to Nasik Cabs often visit this sacred temple to seek blessings and perform rituals."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a holy area associated with the Ramayana, featuring temples and ghats along the Godavari River. Visitors using Pune to Nasik Cabs explore this place for its spiritual and historical importance."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is one of India’s most famous wineries, known for wine tasting and scenic views. Travelers using Pune to Nasik Cabs enjoy relaxing here and experiencing Nashik’s wine culture."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves are ancient rock-cut caves showcasing historical carvings and architecture. Visitors traveling via Pune to Nasik Cabs often explore this site for its heritage and panoramic views."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is a revered temple dedicated to Lord Rama in Panchavati. Devotees booking Pune to Nasik Cabs visit this temple for its spiritual importance and beautiful structure."
  },
  {
    "title": "Muktidham Temple",
    "description": "Muktidham Temple is known for its marble architecture and replicas of the 12 Jyotirlingas. Travelers using Pune to Nasik Cabs often include this peaceful temple in their itinerary."
  },
  {
    "title": "Godavari River Ghat",
    "description": "Godavari River Ghat is a sacred place where pilgrims perform rituals and take holy dips. Visitors using Pune to Nasik Cabs experience the spiritual atmosphere and cultural significance of this location."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Saptashrungi Devi Temple is one of the Shakti Peeths located near Nashik. Travelers booking Pune to Nasik Cabs often visit this temple for a complete religious journey."
  },
  {
    "title": "Coin Museum",
    "description": "Coin Museum in Nashik displays a unique collection of Indian coins and artifacts. Visitors using Pune to Nasik Cabs can explore this place to learn about India’s numismatic history."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Someshwar Waterfall is a scenic spot near Nashik, especially beautiful during the monsoon season. Travelers using Pune to Nasik Cabs enjoy this natural attraction for relaxation and photography."
  }
],



services: [
{
name: "Pune to Nasik Cab Service",
description: "Pune to Nasik cab service offers reliable intercity travel for business and leisure trips. Customers can book comfortable vehicles for smooth highway journeys. Professional drivers ensure safe and timely travel. One-way and round trip options are available. Transparent pricing ensures affordable fares. Travel easily between Pune and Nashik with trusted cab services."
},
{
name: "Affordable Cabs Pune to Nasik",
description: "Affordable cabs Pune to Nasik provide budget-friendly travel options for passengers. Customers can choose economical vehicles for cost-effective journeys. Professional drivers ensure safe and smooth rides. One-way options help reduce travel costs. Transparent pricing ensures no hidden charges. Travel affordably between Pune and Nashik with reliable cab services."
},
{
name: "Pune to Nasik Sula Wine Yards",
description: "Pune to Nasik Sula wine yards cab service offers comfortable travel for wine tourism trips. Customers can enjoy scenic journeys to Sula Vineyards. Professional drivers ensure safe travel on highways. Ideal for group outings and weekend getaways. Flexible booking options are available. Travel conveniently from Pune to Nashik wine yards with cab services."
},
{
name: "Pune to Nasik Car Rental",
description: "Pune to Nasik car rental provides flexible vehicle options for intercity travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe and comfortable journeys. Ideal for family trips and business travel. Transparent pricing ensures affordability. Book car rentals from Pune to Nashik for convenient travel."
},
{
name: "Pune Nasik Taxi Service",
description: "Pune Nasik taxi service offers dependable transportation between the two cities. Customers can book taxis for business trips and tourism. Professional drivers ensure timely and safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures fair fares. Enjoy smooth taxi travel between Pune and Nashik."
},
{
name: "Pune to Nasik Airport Cabs",
description: "Pune to Nasik airport cabs provide reliable transfers to Nashik Airport. Customers can book taxis for timely drop and pickup services. Professional drivers ensure punctual travel. Comfortable vehicles ensure smooth journeys. Transparent pricing ensures affordability. Travel stress-free to Nashik Airport from Pune with cab services."
},
{
name: "Pune to Nasik Outstation Cabs",
description: "Pune to Nasik outstation cabs offer convenient long-distance travel options. Customers can book one-way or round trip rides easily. Comfortable vehicles ensure smooth highway journeys. Professional drivers ensure safe travel. Transparent pricing ensures budget-friendly fares. Choose outstation cab services for Pune to Nashik travel."
},
{
name: "Pune to Nasik Cab Booking Online",
description: "Pune to Nasik cab booking online provides easy and quick reservation options. Customers can book taxis instantly through online platforms. Professional drivers ensure safe and timely journeys. Multiple vehicle options suit different needs. Transparent pricing ensures fair fares. Book your Pune to Nashik cab online for convenience."
},
{
name: "Nasik Dudhsagar Water Falls Taxi",
description: "Nasik Dudhsagar water falls taxi service offers convenient travel to popular waterfall destinations. Customers can enjoy scenic journeys with comfortable vehicles. Professional drivers ensure safe travel on hilly routes. Ideal for tourists and weekend trips. Flexible booking options are available. Explore Nashik waterfalls with reliable taxi services."
},
{
name: "Pune to Nasik Private Cabs",
description: "Pune to Nasik private cabs provide personalized travel experience for passengers. Customers can enjoy private rides without sharing. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe and timely travel. Flexible booking options are available. Travel privately between Pune and Nashik with cab services."
},
{
name: "Pune Nasik One-Way Taxi",
description: "Pune Nasik one-way taxi service offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way taxi services for Pune to Nashik travel."
},
{
name: "Pune to Nasik Round Trip Cabs",
description: "Pune to Nasik round trip cabs provide convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures budget-friendly travel. Book round trip cabs for Pune to Nashik trips."
},
{
name: "Pune to Nasik Cabs",
description: "Pune to Nasik cabs offer reliable transportation between the two cities. Customers can choose from multiple vehicle options. Professional drivers ensure smooth and safe journeys. One-way and round trip options are available. Transparent pricing ensures affordability. Travel comfortably between Pune and Nashik with cab services."
},
{
name: "Cab From Pune to Nasik",
description: "Cab from Pune to Nasik provides convenient travel for business and leisure trips. Customers can book comfortable vehicles easily. Professional drivers ensure safe and timely journeys. Flexible booking options are available. Transparent pricing ensures fair fares. Travel smoothly from Pune to Nashik with cab services."
},
{
name: "Nashik to Pune Private Car",
description: "Nashik to Pune private car service offers comfortable return travel options. Customers can enjoy private rides with flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel privately from Nashik to Pune with car services."
},
{
name: "Nasik to Pune Cab Booking",
description: "Nasik to Pune cab booking service provides easy reservation options for return journeys. Customers can book taxis online or offline. Professional drivers ensure safe and timely travel. Multiple vehicle options suit different needs. Transparent pricing ensures fair fares. Book your Nashik to Pune cab easily."
},
{
name: "Nasik to Pune Cab Service",
description: "Nasik to Pune cab service offers reliable transportation for intercity travel. Customers can book taxis for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel smoothly from Nashik to Pune with cab services."
},
{
name: "Nasik to Pune Cabs",
description: "Nasik to Pune cabs provide dependable travel options between the two cities. Customers can choose from multiple vehicles. Professional drivers ensure smooth journeys. One-way and round trip options are available. Transparent pricing ensures fair fares. Travel comfortably with Nashik to Pune cab services."
},
{
name: "Nasik to Pune Taxi",
description: "Nasik to Pune taxi service offers convenient transportation for daily and long-distance travel. Customers can book taxis easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Enjoy smooth taxi travel from Nashik to Pune."
},
{
name: "Pune Nashik Taxi",
description: "Pune Nashik taxi service provides reliable intercity transportation for travelers. Customers can book taxis for business or leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures fair fares. Travel easily between Pune and Nashik with taxi services."
},
{
name: "Pune Nasik Cab",
description: "Pune Nasik cab service offers comfortable and convenient travel between the two cities. Customers can choose from various vehicle options. Professional drivers ensure safe journeys. Flexible booking options are available. Transparent pricing ensures affordability. Travel smoothly with Pune Nashik cab services."
},
{
name: "Pune Nashik Taxi",
description: "Pune Nashik taxi provides dependable transportation for intercity travel. Customers can book taxis for one-way or round trips. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures fair fares. Choose Pune Nashik taxi services for hassle-free travel."
}
],

tableData: [
["Pune to Nasik Cab Service","Affordable Cabs Pune to Nasik"],
["Pune to Nasik Sula Wine Yards","Pune to Nasik Car Rental"],
["Pune Nasik Taxi Service","Pune to Nasik Airport Cabs"],
["Pune to Nasik Outstation Cabs","Pune to Nasik Cab Booking Online"],
["Nasik Dudhsagar Water Falls Taxi","Pune to Nasik Private Cabs"],
["Pune Nasik One-Way Taxi","Pune to Nasik Round Trip Cabs"],
["Pune to Nasik Cabs","Cab From Pune to Nasik"],
["Nashik to Pune Private Car","Nasik to Pune Cab Booking"],
["Nasik to Pune Cab Service","Nasik to Pune Cabs"],
["Nasik to Pune Taxi","Pune Nashik Taxi"],
["Pune Nasik Cab","Pune Nashik Taxi"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Pune to Nashik Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers who are well familiar with the Pune to Nashik highway routes, ensuring safe driving, smooth travel, and timely arrival for every journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Nashik Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Nashik cab services with transparent pricing. Customers get clear fare details including tolls and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Nashik cab bookings, making it easy to travel anytime for business trips, family visits, or religious tours."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained, air-conditioned, and regularly sanitized vehicles to provide a comfortable long-distance journey from Pune to Nashik."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible options including one-way cab service, round-trip bookings, and customized travel plans for Pune to Nashik journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and Pune Airport across all major locations including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Nashik cab bookings due to punctual drivers, reliable vehicles, and professional intercity travel service."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Nashik cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Nashik with professional drivers and comfortable vehicles." },
  { question: "How far is Nashik from Pune?", answer: "The distance between Pune and Nashik is approximately 210 km and the journey takes around 4 to 5 hours depending on traffic." },
  { question: "Is Pune to Nashik cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for Pune to Nashik travel." },
  { question: "Which vehicles are available for Pune to Nashik travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Nashik?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide pickup from home in Pune?", answer: "Yes, we offer doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Nashik cab service online or via phone." },
  { question: "Do you provide drop service to Nashik temples and tourist places?", answer: "Yes, we provide drop services to Trimbakeshwar, Panchavati, and all major locations in Nashik." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Kulkarni",
    feedback:
      "Booked SRS Cab Service from Pune to Nashik. Smooth journey and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Ritu Sharma",
    feedback:
      "Reliable Pune to Nashik cab service. Clean vehicle and comfortable ride for our family trip.",
    rating: 5
  }
];


































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nasik Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Nasik cab services including affordable, private, and outstation cabs. Book trips to Sula Vineyards, Dudhsagar Waterfalls, airport transfers, one-way or round trips, and online cab booking from Pune to Nasik. Enjoy safe, comfortable, and punctual rides with 24x7 booking services.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Nasik Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Nasik cabs with SRS Cab. Affordable, private, and outstation cabs for Sula Vineyards, Dudhsagar Waterfalls, airport transfers, one-way & round trips with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>





 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikcabs;